import React, { useContext, useEffect, useState } from 'react';

import './EppsSubtabla.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBackspace } from "@fortawesome/free-solid-svg-icons";

import SelectControl from '../SelecControl/SelectControl.jsx';

import FormEpp from '../FormEpp/FormEpp.js';

import eppContext from '../../context/eppContext/eppContex.js';
import { estructuraEpp } from '../../utils/estructuras.js';
import { SECUNDARY_COLOR } from '../../constants/colors';
import { useScrollToBottom } from '../../customHooks/useScrollToBottom.js';

const EppsSubtabla = ({epps, setState, tablaSeleccionada, tDocID='', checkboxMode=false}) =>{

    const [data,setData] = useState('');
    const [showAddEpp,setShowAddEpp] = useState(false);
    const [nuevoEditado, setNuevoEditado] = useState("Agregar");
    const [indexToUpdate,setIndexToUpdate] = useState(-1);
    const [options,setOptions] = useState([]);

    const containerRef = useScrollToBottom(epps.length);

    const eContext = useContext(eppContext);
    const {actualizarEppLista,eppIDLista} = eContext;

    const minimizar = () => {
        setShowAddEpp(false);
    }

    const createOptions = () => {
        const copyEpps = JSON.stringify(eppIDLista)
        const eppsList = JSON.parse(copyEpps)
        let optionsE = [];
        if(eppsList.length > 0){
            optionsE = eppsList.map((e) => {return {
                label:e.name, value: e.codEpp, id: e['_id'], name:e.name
            }})
        }
        setOptions({opcionesEpps:optionsE});
    }

    // === Funciones modo tradicional (dropdown) ===
    const handleChangeEpps = (epp = {},i,textAdic = undefined) => {
        setState((prevState) => {
            let preEpps = prevState.epps.slice();
            const copyEpps = JSON.stringify(preEpps)
            const eppsArr = JSON.parse(copyEpps)

            if(textAdic != undefined && Object.keys(epp).length == 0){
                if(eppsArr[i].value !== ''){
                    eppsArr[i].textAdic = textAdic;
                }
                let newState = {...prevState,['epps']:eppsArr};
                return newState;
            }else{
                if(Object.keys(epp).length == 0){
                    eppsArr.splice(i,1);
                }
                else if(eppsArr[i].value !== ''){
                    eppsArr[i] = epp;
                    eppsArr[i].textAdic = "";
                }else{
                    eppsArr[i] = epp;
                    eppsArr[i].textAdic = "";
                    eppsArr.push({...estructuraEpp});
                }
                let newState = {...prevState,['epps']:eppsArr};
                return newState;
            }
        })
    }

    const handleDeleteEpp = (epp,index) => {
        setState((prevState) => {
            let eppsArr = prevState.epps.slice();
            if(eppsArr.length > 0 && index > -1 && epp.label !== ''){
                eppsArr = prevState.epps.filter((e,i) => i !== index);
            }
            let newState = {...prevState,['epps']:eppsArr};
            return newState;
        });
    }

    // === Funciones modo checkbox ===
    const findCheckedEpp = (catalogEpp) => {
        if(!epps || epps.length === 0) return null;
        return epps.find(e => e.value === catalogEpp.codEpp || e.codEpp === catalogEpp.codEpp);
    }

    const handleToggleEpp = (catalogEpp, checked) => {
        setState((prevState) => {
            let currentEpps = prevState.epps ? prevState.epps.filter(e => e.label !== '') : [];

            if(checked) {
                const existing = currentEpps.find(e => e.value === catalogEpp.codEpp || e.codEpp === catalogEpp.codEpp);
                if(!existing) {
                    currentEpps.push({
                        value: catalogEpp.codEpp,
                        label: catalogEpp.name,
                        id: catalogEpp._id,
                        codEpp: catalogEpp.codEpp,
                        name: catalogEpp.name,
                        textAdic: ''
                    });
                }
            } else {
                currentEpps = currentEpps.filter(e =>
                    e.value !== catalogEpp.codEpp && e.codEpp !== catalogEpp.codEpp
                );
            }

            return {...prevState, epps: currentEpps};
        });
    }

    const handleChangeTextAdic = (catalogEpp, textAdic) => {
        setState((prevState) => {
            let currentEpps = prevState.epps ? prevState.epps.slice() : [];
            const index = currentEpps.findIndex(e => e.value === catalogEpp.codEpp || e.codEpp === catalogEpp.codEpp);
            if(index > -1) {
                currentEpps[index] = {...currentEpps[index], textAdic};
            }
            return {...prevState, epps: currentEpps};
        });
    }

    const handleChangeEppsCheckbox = (epp = {}, index) => {
        if(Object.keys(epp).length === 0) {
            setState((prevState) => {
                let currentEpps = prevState.epps ? prevState.epps.slice() : [];
                currentEpps = currentEpps.filter(e =>
                    e.value !== data.value && e.codEpp !== data.codEpp
                );
                return {...prevState, epps: currentEpps};
            });
        } else {
            setState((prevState) => {
                let currentEpps = prevState.epps ? prevState.epps.slice() : [];
                const idx = currentEpps.findIndex(e => e.id === epp.id || e.value === epp.value);
                if(idx > -1) {
                    currentEpps[idx] = {...currentEpps[idx], ...epp};
                }
                return {...prevState, epps: currentEpps};
            });
        }
    }

    useEffect(()=>{
        createOptions();
    },[eppIDLista])

    return <div className={`${(tablaSeleccionada != 'epps') && 'inactive'} eppsDiv`}>
    <label>Elementos de Protección Personal (EPP)</label>
    <div className="eppsXtransactionDoc" ref={containerRef}>
        {checkboxMode ? (
            // === MODO CHECKBOX ===
            <>
            {(!eppIDLista || eppIDLista.length === 0) ? <div style={{display:'flex', alignItems:'center', gap:'0.5rem'}}>
                <h5 style={{marginBottom:0}}>No hay EPPs cargados en el sistema.</h5>
                <button className="button-add-form" style={{backgroundColor: SECUNDARY_COLOR, borderRadius:'5px', padding:'0.25rem 1rem', fontSize:'1.2rem'}} onClick={() => { setNuevoEditado("Agregar"); setData(''); setShowAddEpp(true); }}>+</button>
            </div> :
            eppIDLista.map((catalogEpp, i) => {
                const checkedEpp = findCheckedEpp(catalogEpp);
                const checked = !!checkedEpp;
                return <div className="eppDiv" key={`${catalogEpp.codEpp}-${i}`}>

                    <SelectControl placeholder={"Seleccione un EPP..."} modo={"Nuevo"} setShowAdd={setShowAddEpp} idSelect={"epp"} handleChengeSelect={()=>{}} optionsSelect={options.opcionesEpps} valueSeleccionada={{value: catalogEpp.codEpp, label: catalogEpp.name, id: catalogEpp._id, name: catalogEpp.name}} tipo={'eppOT'} selectSelect={()=>{}} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                    <label className='customCheckbox'>
                        <input value={checked} className='checkboxTask' type='checkbox' checked={checked} onChange={(e) => handleToggleEpp(catalogEpp, e.target.checked)}/>
                        <span className={`${checked ? 'checked' : ''}`}></span>
                    </label>

                    <input className="inputTextAdic" name="textAdic" value={checked ? (checkedEpp.textAdic || '') : ''} onChange={(e) => handleChangeTextAdic(catalogEpp, e.target.value)} placeholder="Ingrese texto adicional..." disabled={!checked}/>
                </div>
            })
            }
            </>
        ) : (
            // === MODO TRADICIONAL (DROPDOWN) ===
            <>
            {(epps == undefined) ? <h5>Cargando EPPs...</h5> :
            epps.length > 0 && epps.map((epp,i) =><div className="eppDiv" key={`${epp.codEpp}-${i}`}>
                <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '80px', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDeleteEpp(epp,i)} />

                <SelectControl placeholder={"Seleccione un EPP..."} modo={"Nuevo"} setShowAdd={setShowAddEpp} idSelect={"epp"} handleChengeSelect={handleChangeEpps} optionsSelect={options.opcionesEpps} valueSeleccionada={epp} tipo={'eppOT'} selectSelect={handleChangeEpps} setData={setData} index={i} setNuevoEditado={setNuevoEditado} setIndexToUpdate={setIndexToUpdate} />

                <input className="inputTextAdic" name="textAdic" value={epp.textAdic} onChange={(e) => handleChangeEpps({},i,e.target.value)} placeholder="Ingrese texto adicional..."/>
            </div>)
            }
            </>
        )}
        {showAddEpp && <FormEpp data={data} setData={setData} minimizar={minimizar} nuevoEditado={nuevoEditado} handleChangeEpps={checkboxMode ? handleChangeEppsCheckbox : handleChangeEpps} index={indexToUpdate} tDocID={tDocID}/> }
    </div>
    </div>
}

export default EppsSubtabla;
